// Real in-app phone screenshots shown on feature pages ("see it in the app").
// Only features with a shot appear with the device image; others render text-only.
import finance from '../../assets/feature_finance.png';
import products from '../../assets/feature_products.png';
import marketing from '../../assets/feature_marketing.png';

export const FEATURE_SHOTS = {
  finance,
  products,
  marketing,
};
